import store from '@/store';
import router from '@/router';
import mediator from '@/mediator';

export default {
	async initApp () {
	 	try {
			// mostramos el spinner durante el proceso de boot
			store.dispatch('hideContent');
			//  await mediator.auth.init();
			const enoughData = this.checkEnoughData();
			const state = store.state.persistent;

			if (enoughData) return;
			else {
				console.log('not enough data!');
				if (!state.academicYear || !state.academicYears || state.academicYears.length == 0) router.push('/coaching/schools');
				if (!state.schools || state.schools.length > 1) router.push('/coaching/schools');
				else if (state.schools) store.dispatch('setSchool', state.schools[0]);
			}

		} catch (error) {
			/*router.replace({
				path: '/login'
			});*/
			console.log(error);
		} finally {
			store.dispatch('showContent');
		}
	},

	checkEnoughData () {
		const state = store.state.persistent;
		console.log('checkEnoughData', state);
		if (!state.school) return false;
		if (!state.academicYear) return false;
		if (!state.academicYears) return false;
		if (!state.schools) return false;
		return true;
	}

};



// WEBPACK FOOTER //
// ./src/mediator/boot.js